var map = {
	"./ALL.png": "1d33",
	"./GOOGLE.png": "1709",
	"./ITUNES.png": "cbe5",
	"./KDDI.png": "75d9",
	"./ONESTORE.png": "c4d8",
	"./SAMESUNG.png": "83a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abc0";